<script setup>

import { Pagination, Autoplay } from 'swiper/modules';
import Scrollama from 'vue-scrollama'

import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
// 👉 подключаем модули
const modules = [Pagination, Autoplay]

const breakpoints = {
  0: {
    slidesPerView: 1,
    spacebetween:0
  },
  800: {
    slidesPerView: 2,
    spacebetween:0
  },
  1200: {
    slidesPerView: 3,
    spacebetween:50
  }
}
import { onMounted,ref, onUnmounted, onBeforeUnmount} from 'vue';
import Header from './components/HeaderHeader.vue'
import Modals from './components/ModalsModals.vue'
import Preloader from './components/PreloaderPreloader.vue'
import Footer from './components/FooterFooter.vue'


import M from "materialize-css";
import axios from "axios";
import conf from "../config";

// База
const isLoading     = ref(true)
const pageLoaded    = ref(false)
const dataLoaded    = ref(false)

const tryFinishLoading = () => {
  if (pageLoaded.value && dataLoaded.value) {
    isLoading.value = false
  }
}

const handleLoad = () => {
  pageLoaded.value = true
  prefetchPages()
  tryFinishLoading()
}

const prefetchPages = () => {
  if (navigator.connection?.saveData) return

  const run = () => {
    ['/independent', '/standard', '/personal', '/beginner'].forEach((url) => {
      const link = document.createElement('link')
      link.rel = 'prefetch'
      link.href = url
      document.head.appendChild(link)
    })
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(run)
  } else {
    setTimeout(run, 200)
  }
}

const price         = ref([])
const cookis        = ref(true)
const year          = ref()
const videoRef      = ref(null);
const isDesktop     = ref(false)

const isScrolled    = ref(false)
let ticking         = false

const reloadVideo = () => {
  videoRef.value.currentTime = 0
  videoRef.value.play()
}

const handleScroll = () => {

  if (!ticking) {

    window.requestAnimationFrame(() => {
      isScrolled.value = window.scrollY > 60
      ticking = false
    })
    ticking = true
  }
}


function checkScreen()
{
  isDesktop.value = window.matchMedia('(min-width: 1024px)').matches
}


const handlePageShow = () =>
{
  if (videoRef.value) {
    videoRef.value.play().catch(() => {});
  }
};

const handleVisibilityChange = () =>
{
  if (!document.hidden && videoRef.value) {
    videoRef.value.play().catch(() => {});
  }
};

/*===slideCards===*/
const slideCards = ({ element, index }) =>
{
  if (!isDesktop.value)
  {
    element.classList.add('active')
  }
  else
  {
    setTimeout(() => {
      element.classList.add('active')
    }, index * 300) // задержка между элементами
  }
}

/*===firstDips====*/

const firstDips = ({ element }) =>
{
  element.classList.add('active')
}


// подтверждение куков

const cookiesOk = async () => {
  try {
    const response = await axios.post(conf.url + '/cookies')

    if (response.status === 200) {
      cookis.value = true
      document
          .querySelector('.modalCookes')
          .classList.add('modalCookesOff')

      return true
    }

    return false
  } catch (e) {
    console.log(e)
    return false
  }
}

// onMounted
onMounted(async () => {
  checkScreen()
  window.addEventListener('resize', checkScreen)

  // load
  if (document.readyState === 'complete') {
    handleLoad()
  } else {
    window.addEventListener('load', handleLoad, { once: true })
  }

  year.value = new Date().getFullYear()
  M.AutoInit()

  try {
    const { data } = await axios.post(conf.url + '/lengrich')

    cookis.value = data.cookis
    price.value  = data.price

    if (data.cookis === true) {
      document.querySelector('.modalCookes')?.classList.add('modalCookesOff')
    }

    dataLoaded.value = true
    tryFinishLoading()


  } catch (e) {
    console.log(e)
    dataLoaded.value = true
    tryFinishLoading()
  }

  window.addEventListener('pageshow', handlePageShow)
  window.addEventListener('scroll', handleScroll)
  document.addEventListener('visibilitychange', handleVisibilityChange)

  let cards = document.querySelectorAll('.infoCard');
  cards.forEach(card => {
    card.addEventListener('mousemove', (e) => {
      let rect = card.getBoundingClientRect();
      let mouseX = e.clientX - rect.left;
      let mouseY = e.clientY - rect.top;

      let ripple = document.createElement('div');
      ripple.classList.add('ripple');
      ripple.style.left = `${mouseX}px`;
      ripple.style.top = `${mouseY}px`;

      card.appendChild(ripple);

      ripple.addEventListener('animationend', () => {
        ripple.remove();
      });
    });
  });

  let cardsTwo = document.querySelectorAll('.thecards');
  cardsTwo.forEach(card => {
    card.addEventListener('mousemove', (e) => {
      let rect = card.getBoundingClientRect();
      let mouseX = e.clientX - rect.left;
      let mouseY = e.clientY - rect.top;

      let ripple = document.createElement('div');
      ripple.classList.add('ripple');
      ripple.style.left = `${mouseX}px`;
      ripple.style.top = `${mouseY}px`;

      card.appendChild(ripple);

      ripple.addEventListener('animationend', () => {
        ripple.remove();
      });
    });
  });

  let cardsTarf = document.querySelectorAll('.tarf .infTarif');
  cardsTarf.forEach(card => {
    card.addEventListener('mousemove', (e) => {
      let rect = card.getBoundingClientRect();
      let mouseX = e.clientX - rect.left;
      let mouseY = e.clientY - rect.top;

      let ripple = document.createElement('div');
      ripple.classList.add('ripple');
      ripple.style.left = `${mouseX}px`;
      ripple.style.top = `${mouseY}px`;

      card.appendChild(ripple);

      ripple.addEventListener('animationend', () => {
        ripple.remove();
      });
    });
  });

  let cardsTarfNext = document.querySelectorAll('.tarf .infTarifNext');
  cardsTarfNext.forEach(card => {
    card.addEventListener('mousemove', (e) => {
      let rect = card.getBoundingClientRect();
      let mouseX = e.clientX - rect.left;
      let mouseY = e.clientY - rect.top;

      let ripple = document.createElement('div');
      ripple.classList.add('ripple');
      ripple.style.left = `${mouseX}px`;
      ripple.style.top = `${mouseY}px`;

      card.appendChild(ripple);

      ripple.addEventListener('animationend', () => {
        ripple.remove();
      });
    });
  });

  let swiperBox = document.querySelector('.swiper')
  swiperBox.addEventListener('mousemove', (e) => {
    let rect = swiperBox.getBoundingClientRect();
    let mouseX = e.clientX - rect.left;
    let mouseY = e.clientY - rect.top;

    let ripple = document.createElement('div');
    ripple.classList.add('ripple');
    ripple.style.left = `${mouseX}px`;
    ripple.style.top = `${mouseY}px`;

    swiperBox.appendChild(ripple);

    ripple.addEventListener('animationend', () => {
      ripple.remove();
    });
  });``
})


onBeforeUnmount(() => {
  window.addEventListener('pageshow', handlePageShow);
  document.addEventListener('visibilitychange', handleVisibilityChange);
  window.removeEventListener('resize', checkScreen)
  window.removeEventListener('pageshow', handlePageShow)
});

onUnmounted(() => {
  window.removeEventListener('resize', checkScreen)
  window.removeEventListener('scroll', handleScroll)
})

</script>

<template>
  <Header :isScrolled = "isScrolled"/>
  <main>
    <Preloader v-if="isLoading" />
    <Modals :cookiesOk   = "cookiesOk" />
    <section class="hero">
      <video
          autoplay
          muted
          loop
          playsinline
          webkit-playsinline
          preload="auto"
          poster="@/assets/img/video-desc-preview.jpg"
          class="hero__video"
          v-if="isDesktop"
      >
        <source src="@/assets/video/bg.mp4" type="video/mp4">
      </video>
      <video
          ref="videoRef"
          @ended="reloadVideo"
          autoplay
          muted
          loop
          playsinline
          webkit-playsinline
          preload="auto"
          poster="@/assets/img/mob_video-preview.jpg"
          class="hero__video_mob"
      >
        <source src="@/assets/video/bg_mob.webm" type="video/webm">
        <source src="@/assets/video/bg_mob.mp4" type="video/mp4">
      </video>
      <div class="container">
        <div class="row">
          <div class="col s12">
            <div class="hero__content">
              <img src="@/assets/img/logo.svg" alt="logo">
              <p>Простір структурованих знань</p>
              <h4>Від перших кроків<br>до впевненого<br>трейдингу<button><a href="#tarifAll">обрати курс</a></button></h4>
              <div class="text">
                <span class="span">навчання<span>практика</span>стратегія зростання</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="slide">
      <div class="container slideTips">
        <div class="row">
          <Scrollama class="col s12" @step-enter="firstDips"  :offset="1">
            <div class="first leftIn" style="transition-delay: 0.3s">
              <div class="link_Button">trading</div><div class="link_Button">investing</div><div class="link_Button">blockchain</div><div class="link_Button">DeFi</div>
            </div>
            <div class="rightIn" style="transition-delay: 0.3s">
              <div class="second">
                <div class="link_Button">NFTs</div><div class="link_Button">staking</div><div class="link_Button">mining</div>
              </div>
            </div>
            <div class="first leftIn" style="transition-delay: 0.3s">
              <div class="link_Button">tokens</div><div class="link_Button">airdrops</div><div class="link_Button">exchanges</div><div class="link_Button">analytics</div>
            </div>
          </Scrollama>
        </div>
      </div>
      <section id="whyus" class="section scrollspy two" >
        <div class="container">
          <div class="row">
            <div class="col s12">
              <Scrollama class="cards" @step-enter="slideCards"  :offset="0.9">
                <div class="infoCard">
                   <span class="infoCard_text">
                     <span class="fade-text td_one">Навчання</span><br>
                     <span class="fade-text td_two">на платформі</span><br>
                     <span class="fade-text td_tree">TradeUp</span>
                   </span>
                   <img class="first_img" src="@/assets/img/phones/phone_01.png">
                </div>
                <div class="infoCard">
                  <img class="second_img" src="@/assets/img/phones/phone_02.png">
                  <span class="infoCard_text">
                     <span class="fade-text td_one">Особистий</span><br>
                     <span class="fade-text td_tow">акаунт</span><br>
                     <span class="fade-text td_tree">користувача</span>
                  </span>
                </div>
                <div class="infoCard">
                  <img class="third_img" src="@/assets/img/phones/phone_03.png">
                  <span class="infoCard_text">
                    <span class="fade-text td_one">Структурована</span><br>
                    <span class="fade-text td_tow">та логічна</span><br>
                    <span class="fade-text td_tree">система</span>
                  </span>
                </div>
                <div class="infoCard">
                  <img class="fourth_img" src="@/assets/img/phones/phone_04.png">
                  <span class="infoCard_text">
                    <span class="fade-text td_one">Доступ</span><br>
                    <span class="fade-text td_tow">з десктопу</span><br>
                    <span class="fade-text td_tree">та мобільного</span>
                  </span>
                </div>
                <div class="infoCard">
                  <img class="fifth_img" src="@/assets/img/phones/phone_05.png">
                  <span class="infoCard_text">
                    <span class="fade-text td_one">Програми</span><br>
                    <span class="fade-text td_tow">для різних рівнів</span><br>
                    <span class="fade-text td_tree">підготовки</span>
                  </span>
                </div>
                <div class="infoCard">
                  <img class="sixth_img" src="@/assets/img/phones/phone_06.png">
                  <span class="infoCard_text">
                    <span class="fade-text td_one">Практичні</span><br>
                    <span class="fade-text td_tow">завдання</span><br>
                    <span class="fade-text td_tree">з перевіркою</span>
                  </span>
                </div>
              </Scrollama>
            </div>
          </div>
        </div>
      </section>
    </section>
    <section class="tarifSection">
      <div class="container tarifTen">
        <p class="startText">Оберіть формат<br>який найкраще відповідає<br>вашим цілям<br>та рівню підготовки</p>
        <div class="row">
          <div class="col s12">
            <Scrollama class="firstCurs scrollspy" id="firstCurs" @step-enter="slideCards"  :offset="0.9">
              <div class="thecards cardFirst">
                <div class="dark"></div>
                <h4>
                  <span class="fade-text td_four">Курс для</span><br>
                  <span class="fade-text td_five">Початківців</span>
                </h4>
                <p class="ther">Курс для знайомства з основами та базовими принципами трейдингу<br>без складної термінології. Якщо ви тільки починаєте свій шлях у трейдингу, не маєте досвіду<br>та хочете спокійно розібратися в базових речах,<span> цей курс стане зручним першим кроком</span></p>
                <p class="info_mob">Курс для знайомства з основами та базовими принципами трейдингу без складної термінології. Якщо ви тільки починаєте свій шлях у трейдингу, не маєте досвіду та хочете спокійно розібратися в базових речах,<span> цей курс стане зручним першим кроком</span></p>
                <div class="cardFirst_tip r25">40 міні-уроків</div>
                <div class="cardFirst_tip l15">покрокове знайомство</div>
                <div class="cardFirst_tip l65 r25">уроки по 10–15 хвилин</div>
                <div class="cardFirst_tip l15">платформа TradeUp</div>
                <div class="cardFirst_tip">навчання з ПК і смартфона</div>
                <a href="/beginner" class="cardFirst_tip tip_link">детальніше</a>
              </div>
              <div class="thecards cardSecond">
                <div class="dark"></div>
                <div class="cardSecond_first">
                  <span class="ten fade-text td_four">10$</span>
                  <img class="hundred" src="@/assets/img/100.png">
                </div>
                <div class="textBox">
                  <div class="textBox_text">
                    Курс для Початківців автоматично надається<br><span>безкоштовно </span> при купівлі Основного курсу
                  </div>
                  <div class="textBox_text_mob">
                    Курс для Початківців автоматично надається <span>безкоштовно</span> при купівлі Основного курсу
                  </div>
                </div>
                <div class="textBox_link">
                  <a v-bind:href= "price.beginer">придбати</a>
                </div>
              </div>
            </Scrollama>
          </div>
        </div>
      </div>
      <div class="div" style="position: relative;">
        <div class="container tarifAll scrollspy" id="tarifAll">
          <div class="row" style="position: relative;">
            <div class="col s12" >
              <Scrollama class="cards" @step-enter="slideCards"  :offset="0.9">
                <div class="tarf">
                  <div class="infTarif bor">
                    <div class="dark"></div>
                    <h1 class="title">
                      <span class="fade-text td_one">тариф</span><br>
                      <span class="fade-text td_tow">«Самостійний»</span>
                    </h1>
                    <p class="info"><br>Для тих хто цінує свободу,<br>гнучкість та готовий навчатися<br>самостійно</p>
                    <a href="/independent" class="tip_link">детальніше</a>
                  </div>
                  <div class="infTarifNext bor">
                    <div class="dark"></div>
                    <div class="fullCard idRight">
                      <span>Доступ до матеріалів на 6 місяців</span>
                      <span>Особистий кабінет, мобільний<br>додаток</span>
                      <span>Структурована програма<br>навчання</span>
                      <span>Практичні завдання після<br>кожного модуля</span>
                      <span>Перевірка практичного завдання</span>
                      <span>Додаткові бонусні матеріали</span>
                      <span>Торгові сетапи</span>
                      <span class="off">Можливість ставити запитання<br>та отримувати відповіді</span>
                      <span class="off">Онлайн-зустрічі з куратором</span>
                      <span class="off">Записи всіх онлайн-зустрічей</span>
                      <span class="off">Допомога в написанні<br>торгової стратегії</span>
                      <span class="off">Розбір торгових позицій</span>
                      <span class="off">Розбір типових помилок</span>
                      <span class="off">Пріоритетна перевірка<br>та зворотний зв’язок</span>
                      <span>Курс для Початківців<br>(в подарунок)</span>
                      <a v-bind:href= "price.independent" class="link_Button">придбати за 300 $</a>
                    </div>
                  </div>
                </div>
                <div class="tarf">
                  <div class="infTarif bor">
                    <div class="dark"></div>
                    <h1 class="title">
                      <span class="fade-text td_one">тариф</span><br>
                      <span class="fade-text td_two">«Стандарт»</span>
                    </h1>
                    <p class="info"><br>Для тих хто хоче системно<br>розібратися - формат із підтримкою<br>та зворотним зв'язком</p>
                    <a href="/standard" class="tip_link">детальніше</a>
                  </div>
                  <div class="infTarifNext bor">
                    <div class="dark"></div>
                    <div class="fullCard idRight">
                      <span>Доступ до матеріалів на 9 місяців</span>
                      <span>Особистий кабінет, мобільний<br>додаток</span>
                      <span>Структурована програма<br>навчання</span>
                      <span>Практичні завдання після<br>кожного модуля</span>
                      <span>Перевірка практичного завдання</span>
                      <span>Додаткові бонусні матеріали</span>
                      <span>Торгові сетапи</span>
                      <span>Можливість ставити запитання<br>та отримувати відповіді</span>
                      <span>Онлайн-зустрічі з куратором</span>
                      <span>Записи всіх онлайн-зустрічей</span>
                      <span class="off">Допомога в написанні<br>торгової стратегії</span>
                      <span class="off">Розбір торгових позицій</span>
                      <span class="off">Розбір типових помилок</span>
                      <span class="off">Пріоритетна перевірка<br>та зворотний зв’язок</span>
                      <span>Курс для Початківців<br>(в подарунок)</span>
                      <a v-bind:href= "price.standard" class="link_Button">придбати за 500 $</a>
                    </div>
                  </div>
                </div>
                <div class="tarf">
                  <div class="infTarif Glow">
                    <div class="dark"></div>
                    <h1 class="title">
                      <span class="fade-text td_one">тариф</span><br>
                      <span class="fade-text td_tow">«Personal»</span>
                    </h1>
                    <p class="info ther"><br>Для тих, чия мета – зробити трейдинг основним<br>джерелом доходу через глибоке навчання<br>та професійний підхід</p>
                    <p class="info_mob"><br>Для тих, чия мета – зробити трейдинг основним джерелом доходу через глибоке навчання та професійний підхід</p>
                    <a href="/personal" class="tip_link">детальніше</a>
                  </div>
                  <div class="infTarifNext Glow">
                    <div class="dark"></div>
                    <div class="fullCard idRight">
                      <span>Доступ до матеріалів на 12 місяців</span>
                      <span>Особистий кабінет, мобільний<br>додаток</span>
                      <span>Структурована програма<br>навчання</span>
                      <span>Практичні завдання після<br>кожного модуля</span>
                      <span>Перевірка практичного завдання</span>
                      <span>Додаткові бонусні матеріали</span>
                      <span>Торгові сетапи</span>
                      <span>Можливість ставити запитання<br>та отримувати відповіді</span>
                      <span>Онлайн-зустрічі з куратором</span>
                      <span>Записи всіх онлайн-зустрічей</span>
                      <span>Допомога в написанні<br>торгової стратегії</span>
                      <span>Розбір торгових позицій</span>
                      <span>Розбір типових помилок</span>
                      <span>Пріоритетна перевірка<br>та зворотний зв’язок</span>
                      <span>Курс для Початківців<br>(в подарунок)</span>
                      <a v-bind:href= "price.personal" class="link_Button">придбати за 700 $</a>
                    </div>
                  </div>
                </div>
              </Scrollama>
            </div>
            <a href="#form" class="modal-trigger emailBooton">записатися на навчання</a>
          </div>
        </div>
        <div class="container reviews scrollspy" id="tips">
          <p class="startText">Усвідомлене<br>навчання<br>трейдингу</p>
          <div class="row">
            <div class="col s12">
              <Scrollama class="dirs" @step-enter="slideCards"  :offset="0.7">
                <div class="dir dirsleftIn">
                  <div class="dot">
                    <span class="num">1</span>
                  </div>
                  <div class="pill">
                    <span class="text">Розуміння руху ціни</span>
                    <div class="glow"></div>
                  </div>
                </div>
                <div class="dir dirstopIn" style="transition-delay: 0.2s">
                  <div class="dot">
                    <span class="num">2</span>
                  </div>
                  <div class="pill">
                    <span class="text">Логіка входів і виходів</span>
                    <div class="glow"></div>
                  </div>
                </div>
                <div class="dir dirsrightIn" style="transition-delay: 0.3s">
                  <div class="dot">
                    <span class="num">3</span>
                  </div>
                  <div class="pill">
                    <span class="text">Контроль ризиків</span>
                    <div class="glow"></div>
                  </div>
                </div>
                <div class="dir dirsleftIn" style="transition-delay: 0.4s">
                  <div class="dot">
                    <span class="num">4</span>
                  </div>
                  <div class="pill">
                    <span class="text">Аналіз власних дій</span>
                    <div class="glow"></div>
                  </div>
                </div>
                <div class="dir dirsbottomIn" style="transition-delay: 0.5s">
                  <div class="dot">
                    <span class="num">5</span>
                  </div>
                  <div class="pill">
                    <span class="text">Систематизація процесу торгівлі</span>
                    <div class="glow"></div>
                  </div>
                </div>
                <div class="dir dirsrightIn" style="transition-delay: 0.6s">
                  <div class="dot">
                    <span class="num">6</span>
                  </div>
                  <div class="pill">
                    <span class="text">Персональна стратегія для Вас</span>
                    <div class="glow"></div>
                  </div>
                </div>
              </Scrollama>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="reviewsSection">
      <div class="container bgContainer">
        <div class="row">
          <div class="col s12">
            <Swiper
                :modules="modules"
                :loop="true"
                :slides-per-view="3"
                :breakpoints="breakpoints"
                :pagination="{clickable:true}"
                :autoplay="{delay: 5000,disableOnInteraction: false}"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
            >
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar first"></div>
                  <div class="rew">
                    <span class="name">Максим</span>
                    <span class="profession">Тариф Стандарт</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9734;</span></span>
                    <span class="itRow">Проходив навчання в Trade UP, брав стандарт дуже задоволений. Нарешті зрозумів логіку ринку, а не просто дивився на графік.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar second"></div>
                  <div class="rew">
                    <span class="name">Богдан</span>
                    <span class="profession">Тариф Personal</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></span>
                    <span class="itRow">Починав з нуля, взяв тариф Personal. Завдяки кураторам все стало на свої місця, вже є перші результати.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar third"></div>
                  <div class="rew">
                    <span class="name">Alex</span>
                    <span class="profession">Тариф Самостійний</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></span>
                    <span class="itRow">Дякую Trade UP за навчання. Раніше пробував торгувати не виходило, зараз є чітке розуміння що робити.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar fourth"></div>
                  <div class="rew">
                    <span class="name">💚</span>
                    <span class="profession">Тариф Самостійний</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></span>
                    <span class="itRow">Сподобалась структура курсу і платформа. Дуже зручно вчитись навіть з телефону.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar fifth"></div>
                  <div class="rew">
                    <span class="name">07g</span>
                    <span class="profession">Тариф Самостійний</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></span>
                    <span class="itRow">Брав самостійний тариф, але навіть там інформації достатньо щоб зрозуміти базу і почати.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar sixth"></div>
                  <div class="rew">
                    <span class="name">Viktor</span>
                    <span class="profession">Тариф Personal</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></span>
                    <span class="itRow">Куратори в Trade UP реально допомагають. Розбирали мої помилки і це сильно прокачало.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar seventh"></div>
                  <div class="rew">
                    <span class="name">Леша</span>
                    <span class="profession">Тариф Стандарт</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></span>
                    <span class="itRow">Після курсу почав інакше дивитись на ринок. З’явилась логіка і впевненість у діях.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar eighth"></div>
                  <div class="rew">
                    <span class="name">Kris</span>
                    <span class="profession">Тариф Самостійний</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></span>
                    <span class="itRow">Дуже крута подача матеріалу, все по поличках. Навіть складні речі стали зрозумілими.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar ninth"></div>
                  <div class="rew">
                    <span class="name">x_Val</span>
                    <span class="profession">Тариф Personal</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></span>
                    <span class="itRow">Брав Personal це взагалі інший рівень. Індивідуальні заняття дали максимальний результат.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardBox">
                  <div class="rowavatar tenth"></div>
                  <div class="rew">
                    <span class="name">MG</span>
                    <span class="profession">Тариф Стандарт</span>
                    <span class="stars"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></span>
                    <span class="itRow">Раніше трейдинг здавався хаосом, зараз бачу структуру і розумію рух ціни.</span>
                  </div>
                  <div class="rowIn"></div>
                </div>
              </swiper-slide>
            </Swiper>
            <p class="endText">
              Персональне<br>навчання торгівлі<br>без зайвого шуму<br>та чужого темпу
            </p>
          </div>
        </div>
      </div>
    </section>
  </main>
  <Footer :year = "year"/>

</template>



<style>
/* root */
:root
{
  --color: #02ff11;
}

/*
width: clamp(107px, 9vw, 172px);
clamp(МИНИМУМ, ЖЕЛАЕМОЕ, МАКСИМУМ)
макс * 0.625 ≈ МИНИМУМ px
макс / 1920 × 100 ≈ ЖЕЛАЕМОЕ vw
*/


/* fonts */
@font-face {
  font-family: ShareTechMono;
  font-weight: 400;
  src: url(@/assets/fonts/ShareTechMono-Regular.ttf);
}

@font-face {
  font-family: HeliosExtBlackC;
  font-weight: 400; /* normal */
  src: url(@/assets/fonts/HeliosExtBlackC.ttf);
}

@font-face {
  font-family: HeliosExtBlackC;
  font-weight: 700; /* bold */
  src: url(@/assets/fonts/HeliosExtBlackC.ttf);
}

@font-face {
  font-family: HeliosExtC;
  font-weight: 400;
  src: url(@/assets/fonts/HeliosExtC.ttf);
}

@font-face {
  font-family: HeliosExtC-Bold;
  font-weight: 400;
  src: url(@/assets/fonts/HeliosExtC-Bold.ttf);
}

@font-face {
  font-family: HeliosExtThinC;
  font-weight: 400;
  src: url(@/assets/fonts/HeliosExtC.ttf);
}

@font-face {
  font-family: HeliosExtThinCNew;
  font-weight: 400;
  src: url(@/assets/fonts/HeliosExtThin.ttf);
}

/* общие */

#app
{
  font-family: HeliosExtBlackC;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

body,html
{
  background: #000;
}

body
{
  overflow-x: hidden;
  color: #FFFFFF;
}

main
{
  flex: 1 0 auto;
  overflow-x: hidden;
}


p, h1, h4, h3, h2, h1, span
{
  -webkit-user-select: none; /* Chrome, Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* старый Edge */
  user-select: none;
}


.row .col
{
  padding: 0!important;
}

.dark
{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.dark::before
{
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #040404;
  opacity: 0.81;
}

.tl
{
  margin: 0 1px
}

/* hero */

.hero
{
  position: relative;
  min-height: 100vh;
  overflow:visible;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
  letter-spacing: 1px;
}

.hero__content
{
  position: relative;
}

.hero__content img
{
  width: clamp(150px, 12.5vw, 240px);
  position: relative;
  left: 5px;
}

.hero__video
{
  display: block;
  height: 100vh;
  width: 100%;
  -o-object-fit: cover !important;
  object-fit: cover !important;
  overflow-clip-margin: content-box;
  position: absolute;
  top: 0;
  left: 50%;
  right: 0;
  bottom: 0;
  transform: translateX(-50%);
}

.hero__video_mob
{
  display: none;
  height: 100vh;
  width: 100%;
  -o-object-fit: cover !important;
  object-fit: cover !important;
  overflow-clip-margin: content-box;
  position: absolute;
  top: 0;
  left: 50%;
  right: 0;
  bottom: 0;
  transform: translateX(-50%);
}

.hero__content p
{
  font-size: clamp(10.925px, 0.9vw, 17.48px);
  line-height: clamp(13.106px, 1.1vw, 20.97px);
  margin:  135px 0 0 0;
}

.hero__content h4
{
  text-transform: uppercase;

  font-size: clamp(17.475px, 1.45vw, 27.96px);
  line-height: clamp(24.03px, 2vw, 38.45px);
  display: inline-block;
  margin: 0;
  padding-top: 8px;
}

.hero__content button
{
  font-family: HeliosExtBlackC;
  float: right;
  font-size: clamp(8px, 0.66vw, 12.83px);
  background-color: var(--color);
  border: none;
  border-radius: 17.5px;
  padding: clamp(3.125px, 0.26041vw, 5px) clamp(31.875px, 2.65625vw, 51px) clamp(3.125px, 0.26041vw, 5px) clamp(31.875px, 2.65625vw, 51px);
  position: relative;
  top: 6px;
  left: 30px;
  cursor: pointer;
  z-index: 2;
}

.hero__content button a
{
  color: #000;
}

.hero__content .text
{
  font-family: HeliosExtC-Bold;
  margin-top: 135px;
  display: block;
  font-size: clamp(7.46px, 0.62vw, 11.94px);
}

.hero__content .text .span
{
  position: absolute;
  white-space: nowrap;
}

.hero__content .text .span span
{
  margin: 0 clamp(50px, 4.17vw, 80px) 0 clamp(56.25px, 4.69vw, 90px);
}

.hero__content .text .span span:after
{
  content: "•";
  position: relative;
  left: clamp(25px, 2.08vw, 40px);
  top: clamp(1.25px, 0.1vw, 2px);
  color:var(--color);
}

.hero__content .text .span span:before
{
  content: "•";
  position: relative;
  right: clamp(28.13px, 2.34vw, 45px);
  top: clamp(1.25px, 0.1vw, 2px);
  color:var(--color);
}

/* slide */

.slide
{
  margin: 0;
  position: relative;
  overflow: hidden;
  background-image: url(@/assets/img/index_bg_tips.jpg);
  background-repeat: no-repeat;
  background-position: center;
  background-position-y: center;
  padding: 80px 0 0 0;
  background-position-y: -20px;
}



.slide .first
{
  display: flex;
  justify-content: space-between;
}

.slide .second
{
  display: flex;
  justify-content: space-around;
  margin: clamp(43.75px, 3.65vw, 70px) 0;
  width: 80%;
  position: relative;
  left:50%;
  transform: translate(-50%);
}

.slide .first .link_Button,
.slide .second .link_Button
{
  font-family: HeliosExtThinCNew;
  width: clamp(156.25px, 13.02vw, 250px);
  height: clamp(26.25px, 2.19vw, 42px);
  font-size: clamp(11.25px, 0.94vw, 18px);
  border-radius: 25px;
  position: relative;
  line-height: 2.2;
  text-align: center;
  color:rgba(255,255,255,0.5);
}

.slide .first .link_Button::before,
.slide .second .link_Button::before
{
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 25px;
  background: linear-gradient(0deg, rgba(61,61,61, 0.6), rgba(255, 255, 255, 0.4));
  -webkit-mask:
      linear-gradient(rgba(255, 255, 255, 0.91) 0 0) content-box,
      linear-gradient(rgba(255, 255, 255, 0.91) 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
}

/* two */

.two
{
  margin: 180px 0 30px 0;
}

.two .container .row .col .cards
{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(10.63px, 0.89vw, 17px);
}

.two .container .row .col .cards .infoCard
{
  height: clamp(371.25px, 30.94vw, 594px);
  border-radius: 51px;
  position: relative;
  line-height: 2;
  text-align: center;
  font-size: 25px;
  background-image: -moz-linear-gradient( -44deg, rgb(255,255,255,0.1) 0%, rgba(255,255,255,0.1) 100%);
  background-image: -webkit-linear-gradient( -44deg, rgb(255,255,255,0.1) 0%, rgba(255,255,255,0.1) 100%);
  background-image: linear-gradient( -44deg, rgb(255,255,255,0.1) 0%, rgba(255,255,255,0.1) 100%);
  overflow: hidden;
}

.two .container .row .col .cards .infoCard .infoCard_text
{
  font-family: "HeliosExtC-Bold";
  font-size: clamp(11.25px, 0.94vw, 18px);
  line-height: clamp(14.38px, 1.2vw, 23px);
  bottom: clamp(40.63px, 3.39vw, 65px);
  left: clamp(31.25px, 2.6vw, 50px);
  color: #fff;
  position: absolute;
  text-align: left;
}

.two .container .row .col .cards .infoCard img
{
  position: absolute;
  height: 128%;
  z-index: 1;
}

.two .container .row .col .cards .infoCard .first_img
{
  top: clamp(-104px, -5.42vw, -65px);
  right: clamp(-146px, -7.6vw, -91.25px);
}

.two .container .row .col .cards .infoCard .second_img
{
  top: clamp(-116px, -6.04vw, -72.5px);
  right: clamp(-141px, -7.34vw, -88.13px);
}

.two .container .row .col .cards .infoCard .third_img
{
  top: clamp(-110px, -5.73vw,-68.75px );
  right: clamp(-147px, -7.66vw, -91.88px);
}

.two .container .row .col .cards .infoCard .fourth_img
{
  top: clamp(-101px, -5.26vw, -63.13px);
  right: clamp(-153px, -7.97vw, -95.63px);
}

.two .container .row .col .cards .infoCard .fifth_img
{
  top: clamp(-103px, -5.36vw, -64.38px);
  right: clamp(-145px, -7.55vw, -90.63px);
}

.two .container .row .col .cards .infoCard .sixth_img
{
  top: clamp( -102px, -5.31vw,-63.75px);
  right: clamp(-135px, -7.03vw, -84.38px);
}


.two .container .row .col .cards .infoCard::before
{
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 51px;
  background: linear-gradient(0deg, #3d3d3d, rgba(255,255,255,0.5));
  -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: 2;
}

.two .container .row .col .cards .infoCard::after
{
  content: "";
  position: absolute;
  inset: -50%;
  background: radial-gradient(circle at top left,#0C4 35%,transparent 45%);
  filter: blur(53px);
  opacity: .6;
  transform: rotate(20deg);
  transition: all .4s ease;
}

.two .container .row .col .cards .infoCard .ripple,
.tarifTen .row .col .firstCurs .thecards .ripple,
.tarifAll .row .col .cards .tarf .infTarif .ripple,
.tarifAll .row .col .cards .tarf .infTarifNext .ripple,
.swiper .ripple
{
  position: absolute;
  height:5px;
  width: 5px;
  background: var(--color);
  transform: translate(-50%,-50%);
  background: radial-gradient(circle, #0C4 0%, transparent 70%);
  animation: ripple 0.8s ease-out forwards;
  z-index: 3;
}

@keyframes ripple
{
  0%{
    width: 0px;
    height: 0px;
    opacity: 1;
  }
  100%{
    width: 400px;
    height: 400px;
    opacity: 0;
  }
}

/* tarifSection */

.tarifSection
{
  position: relative;
  overflow: hidden;
  background-image: url("@/assets/img/index_bg_3.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-position-y: -210px;
}

/* tarifSection tarifTen */

.div
{
  position: relative;
  overflow: hidden;
  background-image: url("@/assets/img/index_gless.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-position-y: 760px;
}

.tarifTen .startText
{
  position: relative;
  font-family: HeliosExtThinCNew;
  font-size: clamp(10.92px, 0.91vw, 17.47px);
  text-align: center;
  text-transform: uppercase;
  color:#fff;
  white-space: nowrap;
  margin: 0;
  top:150px;
  z-index: 1;
}

.tarifTen .row .col .firstCurs
{
  margin-top: 240px;
  gap: clamp(12.5px, 1.04vw, 20px);
  display: grid;
  grid-template-columns: repeat(1, 2fr 1fr);

}

.tarifTen .row .col .firstCurs .thecards
{
  display: block;
  height: clamp(325.63px, 27.14vw, 521px);
  font-size: clamp(15.63px, 1.3vw, 25px);
  border-radius: 51px;
  position: relative;
  overflow: hidden;
}

/* tarifTen cardFirst*/

.tarifTen .row .col .firstCurs .thecards.cardFirst
{
  padding: clamp(32.5px, 2.71vw, 52px);
}

.tarifTen .row .col .firstCurs .thecards.cardFirst h4
{
  font-family: HeliosExtC-Bold;
  font-size: clamp(17.46px, 1.46vw, 27.94px);
  padding-top: clamp(21.88px, 1.82vw, 35px);
  color: var(--color);
  margin: 0;
  z-index: 1;
  position: relative;
}

.tarifTen .row .col .firstCurs .thecards.cardFirst p
{
  font-family: HeliosExtThinC;
  font-size: clamp(8.73px, 0.73vw, 13.97px);
  padding-top: clamp(33.75px, 2.81vw, 54px);
  padding-bottom: clamp(16.25px, 1.35vw, 26px);
  margin: 0;
  z-index: 1;
  position: relative;
}

.tarifTen .row .col .firstCurs .thecards.cardFirst p span
{
  color: var(--color);
}

.tarifTen .row .col .firstCurs .thecards.cardFirst .cardFirst_tip
{
  border-radius: 17.5px;
  background-color: #1f1f1f;
  color: #fff;
  font-size: clamp(7.5px, 0.63vw, 12px);
  padding: clamp(2.81px, 0.23vw, 4.5px) clamp(31.25px, 2.6vw, 50px);
  font-family: HeliosExtC-Bold;
  text-align: center;
  width: fit-content;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.tarifTen .row .col .firstCurs .thecards.cardFirst .tip_link
{
  border-radius: 17.5px;
  border:1px solid var(--color);
  color: var(--color);
  background: transparent;
  font-family: HeliosExtBlackC;
  text-align: center;
  width: fit-content;
  font-size: clamp(6.55px, 0.55vw, 10.48px);
  padding: clamp(3.81px, 0.32vw, 6.1px) clamp(43.75px, 3.65vw, 70px);
  margin-top: clamp(21.88px, 1.82vw, 35px);
  display: block;
  cursor: pointer;
  z-index: 6;
  position: relative;
}

.tarifTen .row .col .firstCurs .thecards.cardFirst .cardFirst_tip.r25
{
  margin-right: clamp(15.63px, 1.3vw, 25px);
}

.tarifTen .row .col .firstCurs .thecards.cardFirst .cardFirst_tip.l65
{
  margin-left: clamp(40.63px, 3.39vw, 65px);
}

.firstCurs .thecards:first-child::after
{
  content: "";
  position: absolute;
  inset: -10%;
  background: radial-gradient(circle at top left, #0C4 18%, transparent 35%);
  filter: blur(53px);
  opacity: 0.3;
  transform: rotate(15deg);
}

.firstCurs .thecards:not(:first-child)::after
{
  content: "";
  position: absolute;
  inset: -50%;
  background: radial-gradient(circle at bottom right, #0C4 25%, transparent 40%);
  filter: blur(53px);
  opacity: 0.3;
  transform: rotate(30deg);
}

.firstCurs .thecards::before
{
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 51px;
  background: linear-gradient(0deg, #3d3d3d, rgba(255,255,255,0.5));
  -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: 2;
}

/* tarifTen cardSecond*/

.tarifTen .row .col .cardSecond
{

}

.tarifTen .row .col .cardSecond .cardSecond_first
{
  height: clamp(112.5px, 9.38vw, 180px);
  border-radius: 51px;
  position: relative;
  overflow: hidden;
}


.tarifTen .row .col .cardSecond .cardSecond_first::after
{
  content: "";
  position: absolute;
  inset: -50%;
  background: radial-gradient(circle at bottom left, #0c4 35%, transparent 74%);
  filter: blur(53px);
  opacity: .8;
  transform: rotate(-20deg);
}

.tarifTen .row .col .cardSecond .cardSecond_first .ten
{
  font-family: "HeliosExtBlackC";
  z-index: 1;
  position: absolute;
  font-size: clamp(32.75px, 2.73vw, 52.4px);
  left: clamp(22.5px, 1.88vw, 36px);
  bottom: clamp(5px, 0.42vw, 8px);
}

.tarifTen .row .col .cardSecond .cardSecond_first .hundred
{
  position: absolute;
  right: clamp(30px, 2.5vw, 48px);
  top: clamp(36px, 3vw, 57.6px);
  width: clamp(115px, 9.58vw, 184px);
  z-index: 2;
}

.tarifTen .row .col .cardSecond .textBox
{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: clamp(15.63px, 1.3vw, 25px);
}

.tarifTen .row .col .cardSecond .textBox .textBox_text
{
  font-family: "HeliosExtThinC";
  font-size: clamp(8.73px, 0.73vw, 13.97px);
  color: #fff;
  position: relative;
}

.tarifTen .row .col .cardSecond .textBox .textBox_text_mob
{
  font-family: "HeliosExtThinC";
  font-size: 13.97px;
  color: #fff;
  position: relative;
  display: none;
}

.tarifTen .row .col .cardSecond .textBox_text span,
.tarifTen .row .col .cardSecond .textBox_text_mob span
{
  color: var(--color);
}

.tarifTen .row .col .cardSecond .textBox_link
{
  border-radius: 17.5px;
  background: var(--color);
  font-family: HeliosExtBlackC;
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  font-size: clamp(6.55px, 0.55vw, 10.48px);
  padding: clamp(3.81px, 0.32vw, 6.1px) clamp(53.44px, 4.45vw, 85.5px);
  bottom: clamp(32.5px, 2.71vw, 52px);
  display: block;
  cursor: pointer;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  z-index: 6;
}

.tarifTen .row .col .cardSecond .textBox_link a
{
  color: #000;
}

/* tarifSection tarifAll*/

.container.tarifAll
{
  margin-top: 240px;
}

.tarifAll .row .col .cards
{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(10.63px, 0.89vw, 17px);
}

.tarifAll .row .col .cards .tarf .infTarif
{
  display: block;
  border-radius: 51px;
  position: relative;
  overflow: hidden;
}

.tarifAll .row .col .cards .tarf .infTarifNext
{
  display: block;
  border-radius: 51px;
  position: relative;
  overflow: hidden;
  margin-top: clamp(10.63px, 0.89vw, 17px);
  background: rgba(1,1,1,0.6);
}

.tarifAll .row .col .cards .tarf .infTarif.bor::before,
.tarifAll .row .col .cards .tarf .infTarifNext.bor::before
{
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 51px;
  background: linear-gradient(0deg, #ece5e52e, hsla(0, 0%, 100%, .5));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: add, add;
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: 2;
}

.tarifAll .row .col .cards .tarf .infTarif.Glow,
.tarifAll .row .col .cards .tarf .infTarifNext.Glow
{
  box-shadow: 0 0 1px #0F6, 0 0 10px #0C4, 0 0 40px rgba(0, 255, 100, 0.1);
}

.tarifAll .row .col .cards .tarf .infTarif::after
{
  content: "";
  position: absolute;
  inset: -50%;
  background: radial-gradient(circle at top left,#00CC44 50%,transparent 50%);
  filter: blur(53px);
  opacity: .2;
  transform: rotate(20deg);
}

.tarifAll .row .col .cards .tarf .infTarif .title
{
  font-family: HeliosExtC-Bold;
  font-size: clamp(17.46px, 1.46vw, 27.94px);
  color: var(--color);
  text-align: center;
  padding: 0;
  margin: clamp(50px, 4.17vw, 80px) 0 clamp(15px, 1.25vw, 24px) 0;
  position: relative;
  z-index: 2;
}

.tarifAll .row .col .cards .tarf .infTarif .info
{
  font-family: HeliosExtThinC;
  font-size: clamp(8.73px, 0.73vw, 13.97px);
  padding: 0;
  margin: 0;
  text-align: center;
  position: relative;
  z-index: 2;
}

.info_mob
{
  display: none;
  font-family: HeliosExtThinC;
  font-size:13.97px;
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 2;
}

.tarifAll .row .col .cards .tarf .infTarif .tip_link
{
  border-radius: 17.5px;
  border: 1px solid var(--color);
  color: var(--color);
  background: transparent;
  font-family: HeliosExtBlackC;
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  font-size: clamp(6.55px, 0.55vw, 10.48px);
  padding: clamp(3.81px, 0.32vw, 6.1px) clamp(43.75px, 3.65vw, 70px);
  margin: clamp(12.5px, 1.04vw, 20px) 0 clamp(18.75px, 1.56vw, 30px) 0;
  display: block;
  cursor: pointer;
  z-index: 6;
  position: relative;
  left: 50%;
  transform: translate(-50%);
}

.infTarifNext .fullCard
{
  border-radius: 51px;
  padding: clamp(37.5px, 3.13vw, 60px) clamp(37.5px, 3.13vw, 60px) 0 clamp(37.5px, 3.13vw, 60px);
}

.infTarifNext .fullCard span
{
  font-family: HeliosExtC-Bold;
  font-size: clamp(7.5px, 0.63vw, 13.5px);
  padding: clamp(3.13px, 0.26vw, 5px) 0;
  display: block;
  position: relative;
}

.infTarifNext .fullCard span.off
{
  color: #6f6f6f;
  text-decoration: line-through;
}

.infTarifNext .fullCard .link_Button
{
  border-radius: 17.5px;
  color: #000;
  background: var(--color);
  font-family: HeliosExtBlackC;
  text-align: center;
  width: 100%;
  font-size: clamp(6.55px, 0.55vw, 10.48px);
  padding: clamp(3.81px, 0.32vw, 6.1px) 0;
  margin: clamp(34.38px, 2.86vw, 55px) auto clamp(43.75px, 3.65vw, 70px) auto;
  display: block;
  cursor: pointer;
  z-index: 6;
  position: relative;
}

.fullCard.idRight::after
{
  content: "";
  position: absolute;
  inset: -50%;
  background: radial-gradient(circle at bottom right, #0C4 35%, transparent 40%);
  filter: blur(53px);
  opacity: 0.2;
}

.fullCard.idLeft::after
{
  content: "";
  position: absolute;
  inset: -50%;
  background: radial-gradient(circle at bottom left, #0C4 35%, transparent 40%);
  filter: blur(53px);
  opacity: 0.2;
}

.reviews .startText
{
  position: relative;
  font-family: HeliosExtThinCNew;
  font-size: clamp(10.89px, 0.91vw, 17.42px);
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  white-space: nowrap;
  margin: 0;
  top: 180px;
  z-index: 1;
}

.reviews .row .col .dirs
{
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(15.63px, 1.3vw, 25px) clamp(75px, 6.25vw, 120px);
  margin: clamp(125px, 10.42vw, 200px) clamp(6.25px, 0.52vw, 10px) 0 clamp(6.25px, 0.52vw, 10px);
  left: clamp(-3.13px, -0.26vw, -5px);
}

.reviews .row .col .dirs .dir
{
  margin: clamp(21.88px, 1.82vw, 35px) 0 0 0;
  position: relative;
}

.reviews .row .col .dirs .dir .dot
{
  position: absolute;
  top: 0;
  left: clamp(3.13px, 0.26vw, 5px);
  width: clamp(27.5px, 2.29vw, 44px);
  height: clamp(27.5px, 2.29vw, 44px);
  border-radius: 50%;
  background: var(--color);
  z-index: 1;
}

.reviews .row .col .dirs .dir .num
{
  font-family: HeliosExtC;
  font-size: clamp(10.89px, 0.91vw, 17.42px);
  left: clamp(7.5px, 0.63vw, 12px);
  top: clamp(5px, 0.42vw, 8px);
  position: absolute;
  color: #000;
}

.reviews .row .col .dirs .dir .pill
{
  position: relative;
  width: calc(96.5% - clamp(15px, 1.25vw, 24px));
  height: clamp(28.01px, 2.33vw, 44.81px);
  left: clamp(18.75px, 1.56vw, 30px);
  border-radius: 25px;
  background: linear-gradient(0deg, #2a2a2a, #000);
  overflow: hidden;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reviews .row .col .dirs .dir .pill::before
{
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 51px;
  background: linear-gradient(0deg, #3d3d3d, rgba(255,255,255,0.5));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: add, add;
  mask-composite: add, add;
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: 2;
}

.reviews .row .col .dirs .dir .pill .glow
{
  position: absolute;
  transform: translateY(-50%);
  left: clamp(-59px, -3.07vw, -36.88px);
  top: 46%;
  width: clamp(65.63px, 5.47vw, 105px);
  height: clamp(65.63px, 5.47vw, 105px);
  background: radial-gradient(circle, var(--color) 0%, rgba(124,252,0,0.4) 34%, transparent 0%);
  filter: blur(3px);
}

.reviews .row .col .dirs .dir .text
{
  font-family: HeliosExtThinC;
  font-size: clamp(8.73px, 0.73vw, 13.97px);
}

/* reviewsSection*/

.reviewsSection
{
  height: 1191px;
  background-image: url(@/assets/img/index_footer.jpg);
  background-repeat: no-repeat;
  background-position: center;
  background-position-y: center;
  background-position-y: -65px;
}

.bgContainer
{
  background-color: rgba(14,14,14,0.9);
  border-radius: 51px;
  position: relative;
  top:200px;
}

.bgContainer::before
{
  content: "";
  position: absolute;
  inset: 0;
  padding: 1px;
  border-radius: 51px;
  background: linear-gradient(0deg, #3d3d3d, rgba(255,255,255,0.5));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: add, add;
  mask-composite: add, add;
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: 2;
}

.swiper
{
  width: 100%;
  height: 530px;
  z-index: 3;
  border-radius: 51px;
}

.swiper-slide
{
  display: flex;
  justify-content: center;
  align-items: end;
  top:-20px;
}

.reviewsSection .container .row .col
{
  max-height: 530px;
}

.reviewsSection .container .row .col .cardBox
{
  position:relative;
  top:-50px
}

.reviewsSection .container .row .col .cardBox .rew
{
  position: relative;
  width: 231.76px;
  height: 307.08px;
  background: #fff;
  border-radius: 20px;
  transform: rotate(-6deg);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.reviewsSection .container .row .col .cardBox .rew .name
{
  font-family: HeliosExtC-Bold;
  font-size: 20.83px;
  color: #0be718;
  transform: rotate(6deg);
  display: block;
  text-align: center;
  padding-top: 93px;
  padding-left: 16px;
  z-index:1;
}

.reviewsSection .container .row .col .cardBox .rew .profession
{
  font-family: HeliosExtC;
  font-size: 12.5px;
  color: #040404;
  text-transform: uppercase;
  transform: rotate(6deg);
  display: block;
  text-align: center;
  padding: 2px 0 0 8px;
  z-index:1;
}

.reviewsSection .container .row .col .cardBox .rew .stars
{
  transform: rotate(6deg);
  display: block;
  color: #0be718;
  padding: 12px 0 20px 0;
  text-align: center;
  z-index:1;
}

.reviewsSection .container .row .col .cardBox .rew .stars span
{
  font-size: 20px;
  padding: 0 8px;
}

.reviewsSection .container .row .col .cardBox .rew .itRow
{
  font-family: HeliosExtC;
  font-size: 12px;
  color: #030303;
  transform: rotate(7deg);
  display: block;
  text-align: center;
  padding: 0 20px;
  line-height: 1;
  z-index:1;
}

.reviewsSection .container .row .col .cardBox .rowIn
{
  position: absolute;
  top:0;
  width: 231.76px;
  height: 307.08px;
  background: var(--color);
  border-radius: 20px;
  z-index:-1;
}

.reviewsSection .container .row .col .cardBox .rowIn::before
{
  content: "";
  position: absolute;
  inset: -20px;
  border-radius: inherit;
  background: #0C4;
  filter: blur(25px);
  opacity: 0.3;
  z-index: -1;
}

.reviewsSection .container .row .col .cardBox .rowavatar
{
  position: absolute;
  top: -110px;
  left: 24px;
  width: 162px;
  height: 162px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0);
  background-color: rgba(0, 0, 0, 0);
  background-color: #fff;
  z-index: 1;
}

.reviewsSection .container .row .col .cardBox .rowavatar.first
{
  background: url("@/assets/img/users/user_01.jpg") center/cover no-repeat;
}

.reviewsSection .container .row .col .cardBox .rowavatar.second
{
  background: url("@/assets/img/users/user_02.jpg") center/cover no-repeat
}

.reviewsSection .container .row .col .cardBox .rowavatar.third {
  background: url("@/assets/img/users/user_03.jpg") center/cover no-repeat;
}

.reviewsSection .container .row .col .cardBox .rowavatar.fourth {
  background: url("@/assets/img/users/user_04.jpg") center/cover no-repeat;
}

.reviewsSection .container .row .col .cardBox .rowavatar.fifth {
  background: url("@/assets/img/users/user_05.jpg") center/cover no-repeat;
}

.reviewsSection .container .row .col .cardBox .rowavatar.sixth {
  background: url("@/assets/img/users/user_06.jpg") center/cover no-repeat;
}

.reviewsSection .container .row .col .cardBox .rowavatar.seventh {
  background: url("@/assets/img/users/user_07.jpg") center/cover no-repeat;
}

.reviewsSection .container .row .col .cardBox .rowavatar.eighth {
  background: url("@/assets/img/users/user_08.jpg") center/cover no-repeat;
}

.reviewsSection .container .row .col .cardBox .rowavatar.ninth {
  background: url("@/assets/img/users/user_09.jpg") center/cover no-repeat;
}

.reviewsSection .container .row .col .cardBox .rowavatar.tenth {
  background: url("@/assets/img/users/user_010.jpg") center/cover no-repeat;
}

.reviewsSection .container .row .col .cardBox .rowavatar::after
{
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(0,204,68,0.5);
}


.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal
{
  bottom: 15px!important;
}

.swiper-pagination-bullet
{
  background: #fff!important;
}

.swiper-pagination-bullet-active
{
  background: var(--color)!important;
}

.endText
{
  position: relative;
  font-family: HeliosExtThinCNew;
  font-size: clamp(10.89px, 0.91vw, 17.42px);
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  white-space: nowrap;
  margin: 0;
  top: 170px;
  z-index: 1;
}

/*==Animations==*/

/*==hover==*/
.slide .first .link_Button,
.slide .second .link_Button
{

  transition: box-shadow .4s linear;
}

.slide .first .link_Button:hover,
.slide .second .link_Button:hover
{
  box-shadow:
      0 0 70px rgba(0,204,68,0.35),
      inset 0 0 25px rgba(255,255,255,0.1);
}

.hero__content button:hover,
.tarifTen .row .col .cardSecond .textBox_link:hover
{
  background: transparent;
  box-shadow: 0 0 0 1px var(--color);
  transition: background 0.3s ease-in-out;
}

.hero__content button:hover a,
.tarifTen .row .col .cardSecond .textBox_link:hover a
{
  color: var(--color);
  transition: color 0.3s ease-in-out;
}

.infTarifNext .fullCard .link_Button:hover
{
  background: transparent;
  box-shadow: 0 0 0 1px var(--color);
  color: var(--color);
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
}


.tarifTen .row .col .firstCurs .thecards.cardFirst .tip_link:hover,
.tarifAll .row .col .cards .tarf .infTarif .tip_link:hover
{
  color: #000;
  background-color: var(--color);
  border: 1px solid transparent;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
}

/*==========*/
/*==isEnter==*/

.infoCard,
.thecards,
.tarf
{
  opacity: 0;
  transform: translateY(200px);
  will-change: transform, opacity;

    transition:
        opacity 1s ease-out,
        transform 1s ease-out;
}

.infoCard.active,
.thecards.active,
.tarf.active
{
  opacity: 1;
  transform: translateY(0);
}

/*====left & right======*/

.leftIn
{
  opacity: 0;
  transform: translateX(-300px);
  will-change: transform, opacity;

  transition:
      opacity 1.2s ease-out,
      transform 1.2s ease-out;
}

.rightIn
{
  opacity: 0;
  transform: translateX(300px);
  will-change: transform, opacity;

  transition:
      opacity 1.2s ease-out,
      transform 1.2s ease-out;
}
.leftIn.active,
.leftIn.active ~ .leftIn
{
  opacity: 1;
  transform: translateX(0px);
}

.leftIn.active ~ .rightIn
{
  opacity: 1;
  transform: translate(0px);
}

/*Dirs*/

.dirsleftIn
{
  opacity: 0;
  transform: translateX(-300px);
  will-change: transform, opacity;

  transition:
      opacity 0.9s ease-out,
      transform 0.9s ease-out;
}

.dirsrightIn
{
  opacity: 0;
  transform: translateX(300px);
  will-change: transform, opacity;

  transition:
      opacity 0.9s ease-out,
      transform 0.9s ease-out;
}

.dirstopIn
{
  opacity: 0;
  transform: translateY(-300px);
  will-change: transform, opacity;

  transition:
      opacity 0.9s ease-out,
      transform 0.9s ease-out;
}

.dirsbottomIn
{
  opacity: 0;
  transform: translateY(300px);
  will-change: transform, opacity;

  transition:
      opacity 0.9s ease-out,
      transform 0.9s ease-out;
}

.dirsleftIn.active
{
  opacity: 1;
  transform: translateX(0px);
}

.dirsleftIn.active  ~ .dirsleftIn
{
  opacity: 1;
  transform: translateX(0px);
}

.dirsleftIn.active ~ .dirsrightIn
{
  opacity: 1;
  transform: translateX(0px);
}

.dirsleftIn.active ~ .dirsbottomIn,
.dirsleftIn.active ~ .dirstopIn
{
  opacity: 1;
  transform: translateY(0);
}


/*====TEXT======*/

.fade-text
{
  opacity: 0;
  filter: blur(6px);
  clip-path: inset(0 100% 0 0);

  transition:
      opacity 1.6s ease,
      filter 1.6s ease,
      clip-path 1.6s ease;
}

.infoCard.active .infoCard_text .fade-text,
.thecards.active h4 .fade-text,
.thecards.active .cardSecond_first .fade-text,
.tarf.active .infTarif .title .fade-text
{
  opacity: 1;
  filter: blur(0);
  clip-path: inset(0 0 0 0);
}

.td_one
{
  transition-delay: 0.4s
}

.td_two
{
  transition-delay: 0.7s
}

.td_tree
{
  transition-delay: 1.1s
}

.td_four
{
  transition-delay: 0.8s
}

.td_five
{
  transition-delay: 0.7s
}
/*==========*/

.emailBooton
{
  border-radius: 17.5px;
  border: 1px solid var(--color);
  color: var(--color);
  background: transparent;
  background-color: transparent;
  font-family: HeliosExtBlackC;
  text-align: center;
  width: calc(40%);
  height: clamp(28.01px, 2.33vw, 44.81px);
  font-size: clamp(16.55px, 0.55vw, 22.48px);
  line-height: 1.7;
  padding: clamp(3.81px, 0.32vw, 6.1px) clamp(43.75px, 3.65vw, 70px);
  display: block;
  cursor: pointer;
  z-index: 6;
  position: absolute;
  bottom: -130px;
  left: 50%;
  transform: translate(-50%);
}

.emailBooton:hover
{
  color: #000;
  background-color: var(--color);
  border: 1px solid transparent;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
}

/*=============*/

input:not([type]):focus:not([readonly]),
input[type=text]:not(.browser-default):focus:not([readonly]),
input[type=password]:not(.browser-default):focus:not([readonly]),
input[type=email]:not(.browser-default):focus:not([readonly]),
input[type=url]:not(.browser-default):focus:not([readonly]),
input[type=time]:not(.browser-default):focus:not([readonly]),
input[type=date]:not(.browser-default):focus:not([readonly]),
input[type=datetime]:not(.browser-default):focus:not([readonly]),
input[type=datetime-local]:not(.browser-default):focus:not([readonly]),
input[type=tel]:not(.browser-default):focus:not([readonly]),
input[type=number]:not(.browser-default):focus:not([readonly]),
input[type=search]:not(.browser-default):focus:not([readonly]),
textarea.materialize-textarea:focus:not([readonly]) {
  border-bottom: 1px solid #02ff11!important;
  box-shadow: 0 1px 0 0 #02ff11!important;
}

/* @media */


@media (max-width: 1200px)
{

  .hero__video
  {
    display: none;
  }
  .hero__video_mob
  {
    display: block;
  }

  .two .container .row .col .cards
  {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .tarifAll .row .col .cards
  {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .tarf:last-child
  {
    position: relative;
    left: 50%;
  }

  .tarifTen .row .col .firstCurs
  {
    display: grid;
    grid-template-columns: none;
  }

  .tarifTen .row .col .firstCurs .thecards.cardSecond
  {
    height: 260px;
  }

  .tarifTen .row .col .cardSecond .textBox .textBox_text
  {
    font-size: 13.97px;
  }

  .tarifTen .row .col .firstCurs .thecards.cardSecond .textBox
  {
    justify-content: left;
    padding: clamp(32.5px, 2.71vw, 52px);
  }

  .tarifTen .row .col .firstCurs .thecards.cardFirst
  {
    height: auto;
  }

  .tarifTen .row .col .firstCurs .thecards.cardFirst .cardFirst_tip:not(:last-child)
  {
    width: 100%;
  }

  .tarifTen .row .col .firstCurs .thecards.cardFirst .cardFirst_tip.l65,
  .tarifTen .row .col .firstCurs .thecards.cardFirst .cardFirst_tip.r25
  {
    margin-right: 0;
    margin-left: 0;
  }

  .tarifTen .row .col .cardSecond .textBox_link
  {
    font-size: 12px;
    position: relative;
    width: 188.337px;
    margin: 35px 0 10px 0;
  }

  .tarifAll .row .col .cards .tarf .infTarif .tip_link
  {
    font-size: 10.48px;
    padding: 6.1px 70px;
    margin: 20px 0 30px 0;
    position: relative;
    left:50%;
    transform: translate(-50%);
  }

  .tarifTen .row .col .firstCurs .thecards.cardFirst .cardFirst_tip
  {
    position: relative;
    left:50%;
    transform: translate(-50%);
    font-size: 12px;
    margin-bottom: 10px;
  }


  /*аниматион*/

  /*====TEXT======*/

  .fade-text
  {
    opacity: 1;
    filter: blur(0);

    transition:
        opacity 0s ease,
        filter 0s ease,
        clip-path 0s ease;
  }

  .dirsleftIn
  {
    opacity: 1;
    transform: translateX(0px);
    will-change: transform, opacity;

    transition:
        opacity 0s ease-out,
        transform 0s ease-out;
  }

  .dirsrightIn
  {
    opacity: 1;
    transform: translateX(0px);
    will-change: transform, opacity;

    transition:
        opacity 0s ease-out,
        transform 0s ease-out;
  }

  .dirstopIn
  {
    opacity: 1;
    transform: translateY(0px);
    will-change: transform, opacity;

    transition:
        opacity 0s ease-out,
        transform 0s ease-out;
  }

  .dirsbottomIn
  {
    opacity: 1;
    transform: translateY(0px);
    will-change: transform, opacity;

    transition:
        opacity 0s ease-out,
        transform 0s ease-out;
  }


  .td_one
  {
    transition-delay: 0s
  }

  .td_two
  {
    transition-delay: 0s
  }

  .td_tree
  {
    transition-delay: 0s
  }

  .td_four
  {
    transition-delay: 0s
  }

  .td_five
  {
    transition-delay: 0s
  }

  /*paddings L*/
  .tarifTen .row .col .firstCurs
  {
    margin-top: 0px;
  }

  .tarifTen .startText
  {
    top: 0px;
    padding: 6px 0 30px 0;
  }

  .reviews .row .col .dirs
  {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: clamp(15.63px, 1.3vw, 25px) clamp(75px, 6.25vw, 120px);
    margin: 0 clamp(6.25px, 0.52vw, 10px) 0 clamp(6.25px, 0.52vw, 10px);
    left: clamp(-3.13px, -0.26vw, -5px);
  }

  .reviews .startText
  {
    margin-top: 60px;
    top:0px;
    padding: 35px 0 0px 0;
    font-size: 17.42px;
  }

  .emailBooton
  {
    width: calc(80%);
    height: clamp(28.01px, 2.33vw, 44.81px);
    font-size: 10.48px;
    line-height: 1.7;
    position: absolute;
    bottom: -70px;
  }

  .bgContainer
  {
    top: 80px;
  }

  .tarifSection
  {
    background-image: url(@/assets/img/mob_index_bg_3.jpg);
  }

  .div
  {
    background-image: url(@/assets/img/mob_index_gless.jpg);
  }

  .reviewsSection
  {
    background-image: url(@/assets/img/mob_index_footer.jpg);
  }

}

@media (max-width: 1024px)
{


}

@media (max-width: 899px)
{

  .hero__content img
  {
    width: 160px;
    position: relative;
    left: 50%;
    top: -110px;
    transform: translate(-50%);
  }

  .hero__content button
  {
    top: 5px;
  }

  /*==Fonts==*/
  .two .container .row .col .cards .infoCard .infoCard_text
  {
    font-size: 18px;
    line-height: 23px;
  }

  .tarifAll .row .col .cards .tarf .infTarif .title
  {

    font-size: 27.94px;
    margin: 80px 0 24px 0;
  }

  .tarifAll .row .col .cards .tarf .infTarif .info
  {
    font-size:13.97px;
    margin-bottom: 50px;
  }

  .ther
  {
    display: none;
  }

  .info_mob
  {
    padding: 0 15px;
    display: block;
    margin-bottom: 50px;
  }

  .infTarifNext .fullCard span
  {
    font-size: 12px;
    padding: 5px 0;
  }

  .infTarifNext .fullCard .link_Button
  {
    font-size: 10.48px;
  }

  .tarifTen .startText
  {
    font-size: 16px;
  }

  .tarifTen .row .col .firstCurs .thecards.cardFirst h4
  {
    font-size: 27.94px;
  }

  .tarifTen .row .col .firstCurs .thecards.cardFirst p
  {
    font-size: 13.97px;
    padding-top: 54px;
    padding-bottom: 40px;
  }

  /*===========*/

  .slide
  {
    padding: 0;
  }

  .slide .slideTips
  {
    display: none;
  }

  .two
  {
    margin: 0px 0 30px 0;
  }


  .container.tarifAll
  {
    margin-top: 40px;
  }

  .tarifTen .row .col .firstCurs .thecards.cardSecond
  {
    height: auto;
  }

  /*==dots==*/

  .reviews .row .col .dirs .dir
  {
    margin: 35px 0 0 0;
  }

  .reviews .row .col .dirs .dir .dot
  {

    left: 5px;
    width: 44px;
    height: 44px;

  }

  .reviews .row .col .dirs .dir .num
  {
    font-size: 17.42px;
    left: 12px;
    top: 8px;
  }

  .reviews .row .col .dirs .dir .pill
  {
    width: calc(96.5% - 24px);
    height: 44.81px;
    left: 30px;
  }

  .reviews .row .col .dirs .dir .pill .glow
  {

    left: -59px;
    width: 105px;
    height: 105px;
  }

  .reviews .row .col .dirs .dir .text
  {
    font-size: 13.97px;
  }

  .endText
  {
    font-size: 17.42px;
  }

}

@media (max-width: 768px)
{

  .tarf:last-child
  {
    left: 0;
  }

  .two .container .row .col .cards
  {
    grid-template-columns: repeat(1, 1fr);
  }

  .tarifAll .row .col .cards
  {
    grid-template-columns: repeat(1, 1fr);
  }

  .reviews .row .col .dirs
  {
    grid-template-columns: repeat(1, 1fr);
  }

}

@media (max-width: 485px)
{

  .textBox_text
  {
    display: none;
  }

  .textBox_text_mob
  {
    display: block!important;
  }

}

@media (max-width: 375px)
{

}

</style>
